
let swiper = new Swiper(".mySwiper", {}, );

swiper = new Swiper(".mySwiperReviews", {
  pagination: {
    el: ".swiper-pagination",
  },
});
